'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const zonedMoment=require('pulsar-utils/dist-es6/time/zonedMoment');let

IntervalService=function(_BaseService){_inherits(IntervalService,_BaseService);_createClass(IntervalService,null,[{key:'$inject',get:function()
{
return['dateService','timeZoneService'];
}}]);

function IntervalService(dateService,timeZoneService){_classCallCheck(this,IntervalService);var _this=_possibleConstructorReturn(this,
_BaseService.call(this));
_this._dateService=dateService;
_this._timeZoneService=timeZoneService;return _this;
}IntervalService.prototype.





_getPointIntervalFromNow=function _getPointIntervalFromNow(){
let now=this._dateService.now();
return TimeInterval.fromPoint(now);
};IntervalService.prototype.
































































_toDisplay=function _toDisplay(interval){
return new TimeInterval(interval.start,interval.end.getTime()-1);
};IntervalService.prototype.

getMonthlyLookbackIntervalIncludingCurrentDayFor=function getMonthlyLookbackIntervalIncludingCurrentDayFor(timezone,totalMonths){
_.ensureInstanceOf('string',timezone);
_.ensureInstanceOf('number',totalMonths);

if(totalMonths<=0){
throw new Error('Unexpected totalMonths');
}

const nowAsMoment=zonedMoment(this._dateService.now(),timezone);




return TimeInterval.
from(nowAsMoment.clone().subtract(totalMonths-1,'months').startOf('month').toDate()).
to(nowAsMoment.clone().endOf('day').toDate());
};_createClass(IntervalService,[{key:'_localTimeZone',get:function(){return this._timeZoneService.localTimeZone}},{key:'today',get:function(){return this._getPointIntervalFromNow().expandToRoundTarget('day',this._localTimeZone)}},{key:'todayForDisplay',get:function(){return this._toDisplay(this.today)}},{key:'thisWeek',get:function(){return this._getPointIntervalFromNow().expandToRoundTarget('week',this._localTimeZone)}},{key:'thisWeekForDisplay',get:function(){return this._toDisplay(this.thisWeek)}},{key:'nextWeek',get:function(){let start=this._getPointIntervalFromNow().expandToRoundTarget('week',this._localTimeZone);return start.shift('week',1,this._localTimeZone)}},{key:'nextWeekForDisplay',get:function(){return this._toDisplay(this.nextWeek)}},{key:'lastWeek',get:function(){let start=this._getPointIntervalFromNow().expandToRoundTarget('week',this._localTimeZone);return start.shift('week',-1,this._localTimeZone)}},{key:'lastWeekForDisplay',get:function(){return this._toDisplay(this.lastWeek)}},{key:'thisMonth',get:function(){return this._getPointIntervalFromNow().expandToRoundTarget('month',this._localTimeZone)}},{key:'thisMonthForDisplay',get:function(){return this._toDisplay(this.thisMonth)}},{key:'lastMonth',get:function(){let start=this._getPointIntervalFromNow().expandToRoundTarget('month',this._localTimeZone);return start.shift('month',-1,this._localTimeZone)}},{key:'lastMonthForDisplay',get:function(){return this._toDisplay(this.lastMonth)}},{key:'previousFourWeeksAndWeekToDate',get:function(){const _now=this._dateService.now();const fourWeeksPriorToLastSunday=zonedMoment(_now,this._localTimeZone).startOf('week').subtract(28,'days').toDate();const midnightTonight=zonedMoment(_now,this._localTimeZone).endOf('day').add(1,'millisecond').toDate();return TimeInterval.from(fourWeeksPriorToLastSunday).to(midnightTonight)}},{key:'previousFourWeeksAndWeekToDateForDisplay',get:function(){return this._toDisplay(this.previousFourWeeksAndWeekToDate)}}]);return IntervalService}(BaseService);


module.exports=IntervalService;
//# sourceMappingURL=intervalService.js.map
